module.exports = __webpack_public_path__ + "assets/b23308ebbb9c3163c45d37d43b4d8475.svg";